import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
}
if (!customElements.get('product-card')) {
  window.ProductCard = ProductCard;
  customElements.define('product-card', ProductCard);
}

class ProductCardSwiper extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.createSwiper();
  }

  createSwiper() {
    this.swiperElement = this.querySelector('[data-product-card-swiper]');

    this.swiperOptions = {
      modules: [A11y, Navigation, Pagination],
      watchOverflow: true,
      preventClicks: true,
      loop: false,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',

        clickable: true,
      },
      slidesPerView: 1,
      direction: 'horizontal',
    };

    // Check if we have extra options on the HTML
    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);
      if (jsonOptions) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...jsonOptions,
        };
      }
    }

    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    if (this.swiperOptions.pagination) {
      this.swiperInstance.pagination.init();
      this.swiperInstance.pagination.update();
    }
  }
}

if (!customElements.get('product-card-swiper')) {
  window.ProductCardSwiper = ProductCardSwiper;

  customElements.define('product-card-swiper', ProductCardSwiper);
}
